export default __webpack_public_path__ + "static/media/ElementBattle.c0106056.png";